import { StoryblokImage } from '@cinch-nx/data-storyblok'
import { StoryblokRenderer } from '@cinch-nx/storyblok-utils'
import { FinanceOffersCarousel } from '@cinch-nx/ui-finance'
import { SbBlokData, StoryData } from '@storyblok/react'
import { atomStoryblokComponents } from '../../data-maps/atom-storyblok-components-map'

export interface FinanceOffersCarouselBlockProps {
  title: string
  description: string
  disclaimer: string
  cards: SbBlokData[]
  placeHolderImage: StoryblokImage
  financeRepresentativeExample?: StoryData[]
}

export function FinanceOffersCarouselBlock({
  title,
  description,
  disclaimer,
  cards,
  placeHolderImage,
  financeRepresentativeExample,
}: FinanceOffersCarouselBlockProps) {
  const offerCards = cards.map((card) => (
    <StoryblokRenderer block={card} components={atomStoryblokComponents} />
  ))

  const finRep = financeRepresentativeExample?.length ? (
    <StoryblokRenderer
      block={financeRepresentativeExample[0]?.content}
      components={atomStoryblokComponents}
    />
  ) : undefined

  return (
    <FinanceOffersCarousel
      title={title}
      description={description}
      disclaimer={disclaimer}
      cards={offerCards}
      placeHolderImage={{
        src: placeHolderImage.filename,
        alt: placeHolderImage.alt ?? '',
      }}
      financeRepresentativeExample={finRep}
    />
  )
}
